import $ from 'jquery';
import SparkResponsiveImages from 'spark-responsive-images';
import './instagram-feed.scss';

/**
 * @constructor
 * @param {Element} element Main element.
 */
class InstagramFeed {
  constructor(element) {
    this.element = element;
    this._url = element.getAttribute('data-feed-type');
    this._fetch()
      .then(this._handleResponse.bind(this))
      .catch(this._handleError.bind(this))
      .then(this._finish.bind(this));
  }

  /**
   * Request markup from the custom instagram api.
   * @return {jqXHR} jQuery XHR object.
   */
  _fetch() {
    return $.ajax({
      url: this._url,
      dataType: 'html',
    });
  }

  /**
   * Handles the AJAX response.
   *
   * @param {string|Object} response
   */
  _handleResponse(response) {
    try {
      let obj = response;

      if (typeof response !== 'object') {
        obj = JSON.parse(response);
      }

      if (!obj.success) {
        this._handleError('something went wrong');
      }
    } catch (e) {
      this._injectMarkup(response);
    }
  }

  /**
   * If the request for instagram images fails, act like we were never here by
   * removing this module from the DOM.
   * @param {jqXHR} err jQuery XHR object.
   */
  _handleError(err) {
    console.error(err); // eslint-disable-line no-console
    $(this.element).remove();
    this.dispose();
  }

  /**
   * Insert the markup returned by the instagra-fragment into the DOM.
   * @param {string} markup HTML string.
   */
  _injectMarkup(markup) {
    this.element
      .querySelector('.instagram-feed__content')
      .insertAdjacentHTML('beforeend', markup);

    const images = this.element.querySelectorAll('.spark-responsive-img');

    SparkResponsiveImages.add(images);
  }

  /**
   * Notify watchers that offsets changed w/o a page resize.
   */
  _finish() {
    SparkResponsiveImages.updateOffsets();
    $(this.element).trigger('instagramfeednewcontent');
  }

  /**
   * Remove element references / event listeners.
   */
  dispose() {
    this.element = null;
  }

  /**
   * Initialize every "instagram-feed" module on the page.
   * @return {Array.<InstagramFeed>}
   */
  static initializeAll() {
    return $('.instagram-feed').map((i, el) => new InstagramFeed(el)).get();
  }
}

export default InstagramFeed;
